import { useParams } from 'react-router-dom';

import { Divider } from 'antd';

import { formatDateTime } from '@/shared/lib/format';
import { MetadataItem } from '@/shared/ui/MetadataItem';

import { formatDagMaturity, formatDagVersionLabel } from '@/entities/dag';
import { useDagOverview } from '@/entities/dag';

import styles from './DagDetailSummaryCard.module.css';

export const DagDetailSummaryCard = () => {
  const params = useParams<{ dagId?: string }>();
  const dagId = params.dagId;

  const { data: overview } = useDagOverview(dagId ?? '');

  const deployedVersion = overview.deployedVersion;
  const latestVersion = overview.latestVersion;

  const summary = {
    runType:
      overview.runType === 'scheduled' ? `${overview.runType} (${overview.schedule})` : (overview.runType ?? '-'),
    nextRun: overview.nextRun ? formatDateTime(overview.nextRun) : undefined,
    lastRun: overview.lastRun ? formatDateTime(overview.lastRun) : undefined,
    maturity: formatDagMaturity(overview.maturity),
    owner: overview.owner,
    latestVersionDisplay:
      latestVersion != null
        ? `${formatDagVersionLabel(latestVersion)}${deployedVersion !== latestVersion ? ' (Undeployed)' : ''}`
        : '-',
  };

  return (
    <div className={styles.summaryCard}>
      <div className={styles.metadata}>
        <MetadataItem title="실행 타입">
          <span className={styles.itemName}>{summary.runType}</span>
        </MetadataItem>
        <Divider type="vertical" className={styles.metadataDivider} />
        <MetadataItem title="다음 실행">
          <span className={styles.itemName}>{summary.nextRun ?? '-'}</span>
        </MetadataItem>
        <Divider type="vertical" className={styles.metadataDivider} />
        <MetadataItem title="마지막 실행">
          <span className={styles.itemName}>{summary.lastRun ?? '-'}</span>
        </MetadataItem>
        <Divider type="vertical" className={styles.metadataDivider} />
        <MetadataItem title="성숙도">
          <span className={styles.itemName}>{summary.maturity}</span>
        </MetadataItem>
        <Divider type="vertical" className={styles.metadataDivider} />
        <MetadataItem title="소유자">
          <span className={styles.itemName}>{summary.owner ?? '-'}</span>
        </MetadataItem>
        <Divider type="vertical" className={styles.metadataDivider} />
        <MetadataItem title="최신 버전">
          <span className={styles.itemName}>{summary.latestVersionDisplay}</span>
        </MetadataItem>
      </div>
    </div>
  );
};
